import { useCallback, useState } from 'react';

const useTextFieldValue = (initialValue = '') => {
  const [value, setValue] = useState(initialValue);
  const wrapper = useCallback((event) => {
    setValue(event.target.value);
  }, []);
  const cleanValue = useCallback(() => {
    setValue('');
  }, []);
  return [value, wrapper, cleanValue];
};

export default useTextFieldValue;
